import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, vModelText as _vModelText, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_2 = { class: "card-body p-4" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-lg-4 col-sm-6" }
const _hoisted_5 = {
  key: 0,
  class: "form-group mb-4"
}
const _hoisted_6 = ["value"]
const _hoisted_7 = { class: "input-error" }
const _hoisted_8 = { class: "col-lg-4 col-sm-6" }
const _hoisted_9 = { class: "form-group mb-4" }
const _hoisted_10 = { class: "input-error" }
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "col-lg-4 col-sm-6" }
const _hoisted_13 = { class: "form-group mb-4" }
const _hoisted_14 = {
  key: 0,
  class: "input-error"
}
const _hoisted_15 = { class: "col-lg-4 col-sm-6" }
const _hoisted_16 = { class: "form-group mb-4" }
const _hoisted_17 = { class: "input-error" }
const _hoisted_18 = { class: "row" }
const _hoisted_19 = { class: "col-lg-4 col-sm-6" }
const _hoisted_20 = { class: "form-group mb-4" }
const _hoisted_21 = {
  key: 0,
  class: "input-error"
}
const _hoisted_22 = { class: "col-lg-4 col-sm-6" }
const _hoisted_23 = { class: "form-group mb-4" }
const _hoisted_24 = { class: "input-error" }
const _hoisted_25 = { class: "row" }
const _hoisted_26 = { class: "col-lg-12" }
const _hoisted_27 = { class: "d-flex flex-wrap gap-3" }
const _hoisted_28 = ["disabled"]
const _hoisted_29 = { key: 0 }
const _hoisted_30 = {
  key: 1,
  class: "spinner-border spinner-border-sm me-2",
  "aria-hidden": "true"
}
const _hoisted_31 = {
  key: 2,
  role: "status"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("form", {
        onSubmit: _cache[12] || (_cache[12] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.validateForm && _ctx.validateForm(...args)), ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            (_ctx.itemsCompanyCategories)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _cache[14] || (_cache[14] = _createElementVNode("label", { class: "label text-secondary" }, "Tipo ", -1 /* HOISTED */)),
                  _withDirectives(_createElementVNode("select", {
                    class: "form-select form-control h-45",
                    "aria-label": "Default select example",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.company.companyCategory) = $event)),
                    onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.clearError('companyCategory')))
                  }, [
                    _cache[13] || (_cache[13] = _createElementVNode("option", { value: null }, "-- Seleccionar --", -1 /* HOISTED */)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.itemsCompanyCategories, (company, i) => {
                      return (_openBlock(), _createElementBlock("option", {
                        value: company.id,
                        key: i
                      }, _toDisplayString(company.name), 9 /* TEXT, PROPS */, _hoisted_6))
                    }), 128 /* KEYED_FRAGMENT */))
                  ], 544 /* NEED_HYDRATION, NEED_PATCH */), [
                    [_vModelSelect, _ctx.company.companyCategory]
                  ]),
                  _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.errors.companyCategory), 1 /* TEXT */)
                ]))
              : _createCommentVNode("v-if", true)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _cache[15] || (_cache[15] = _createElementVNode("label", { class: "label text-secondary" }, "Nombre", -1 /* HOISTED */)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control h-45",
                placeholder: "Ingresar el nombre de la Empresa/Institución",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.company.name) = $event)),
                onInput: _cache[3] || (_cache[3] = ($event: any) => (_ctx.clearError('name')))
              }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                [
                  _vModelText,
                  _ctx.company.name,
                  void 0,
                  { trim: true }
                ]
              ]),
              _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.errors.name), 1 /* TEXT */)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _cache[16] || (_cache[16] = _createElementVNode("label", { class: "label text-secondary" }, "RUC", -1 /* HOISTED */)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control h-45",
                placeholder: "Ingresar el RUC de la Empresa/Institución",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.company.ruc) = $event)),
                maxlength: "11",
                onInput: _cache[5] || (_cache[5] = ($event: any) => (_ctx.clearError('ruc')))
              }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                [
                  _vModelText,
                  _ctx.company.ruc,
                  void 0,
                  { trim: true }
                ]
              ]),
              (_ctx.errors.ruc)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(_ctx.errors.ruc), 1 /* TEXT */))
                : _createCommentVNode("v-if", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _cache[17] || (_cache[17] = _createElementVNode("label", { class: "label text-secondary" }, "Dominio(s) ", -1 /* HOISTED */)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control h-45",
                placeholder: "Ingresar el dominio(s)",
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.company.domains) = $event)),
                maxlength: "300",
                onInput: _cache[7] || (_cache[7] = ($event: any) => (_ctx.clearError('domains')))
              }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                [
                  _vModelText,
                  _ctx.company.domains,
                  void 0,
                  { trim: true }
                ]
              ]),
              _cache[18] || (_cache[18] = _createElementVNode("small", { class: "text-muted" }, " Si ingresa varios dominios, sepárelos por comas. Ej: empresa.com,empresa.org ", -1 /* HOISTED */)),
              _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.errors.domains), 1 /* TEXT */)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _cache[19] || (_cache[19] = _createElementVNode("label", { class: "label text-secondary" }, "Descripción", -1 /* HOISTED */)),
              _withDirectives(_createElementVNode("textarea", {
                rows: "4",
                style: {"resize":"none"},
                class: "form-control text-dark no-resize",
                placeholder: "Ingresar la descripción de la Empresa/Institución",
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.company.description) = $event)),
                onInput: _cache[9] || (_cache[9] = ($event: any) => (_ctx.clearError('description')))
              }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                [
                  _vModelText,
                  _ctx.company.description,
                  void 0,
                  { trim: true }
                ]
              ]),
              (_ctx.errors.description)
                ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(_ctx.errors.description), 1 /* TEXT */))
                : _createCommentVNode("v-if", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("div", _hoisted_23, [
              _cache[20] || (_cache[20] = _createElementVNode("label", { class: "label text-secondary" }, "Alias ", -1 /* HOISTED */)),
              _withDirectives(_createElementVNode("textarea", {
                rows: "4",
                style: {"resize":"none"},
                class: "form-control text-dark no-resize",
                placeholder: "Ingresar alias",
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.company.alias) = $event)),
                onInput: _cache[11] || (_cache[11] = ($event: any) => (_ctx.clearError('alias'))),
                maxlength: "1000"
              }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                [
                  _vModelText,
                  _ctx.company.alias,
                  void 0,
                  { trim: true }
                ]
              ]),
              _cache[21] || (_cache[21] = _createElementVNode("small", { class: "text-muted" }, " Si ingresa varias alias, sepárelos por comas. Ej: EmpresaUno,EmpresaDos ", -1 /* HOISTED */)),
              _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.errors.alias), 1 /* TEXT */)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("div", _hoisted_27, [
              _createVNode(_component_RouterLink, { to: "/companies" }, {
                default: _withCtx(() => _cache[22] || (_cache[22] = [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-danger bg-danger bg-opacity-10 text-danger border-0 fw-semibold py-2 px-4"
                  }, " Cancelar ", -1 /* HOISTED */)
                ])),
                _: 1 /* STABLE */
              }),
              _createElementVNode("button", {
                class: "btn btn-primary bg-primary bg-opacity-10 text-primary border-0 fw-semibold py-2 px-4",
                type: "submit",
                disabled: _ctx.isLoading
              }, [
                (!_ctx.isLoading)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString(_ctx.company.id == 0 ? "Crear" : "Actualizar"), 1 /* TEXT */))
                  : _createCommentVNode("v-if", true),
                (_ctx.isLoading)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_30))
                  : _createCommentVNode("v-if", true),
                (_ctx.isLoading)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_31, "Procesando..."))
                  : _createCommentVNode("v-if", true)
              ], 8 /* PROPS */, _hoisted_28)
            ])
          ])
        ])
      ], 32 /* NEED_HYDRATION */)
    ])
  ]))
}